/* eslint-disable no-undef */
/* eslint-disable import/no-extraneous-dependencies */
import { createGlobalStyle } from 'styled-components';

const path = 'https://d11zrgpbhs014a.cloudfront.net/assets/fonts/SBS_Sans_6/';

export default createGlobalStyle`
  html {
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  body {
    width: 100%;
    margin: 0;
    position: relative;
    left: 0;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    line-height: 1.5em;
    font-family: 'SBS Sans', sans-serif;
    font-weight: 400;
    font-size: 16px;
  }

  .rating-code {
    display: inline-flex;
    box-sizing: border-box;
    width: 42px;
    height: 42px;
    flex: 0 0 42px;
    align-items: center;
    justify-content: center;
    border: 1.5px solid currentColor;
    border-radius: 10px;
    font-family: 'SBS Sans', sans-serif;
    font-stretch: condensed;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1;
    text-align: center;
  }

  .rating-code--no-shortage {
    border-color: #167a3a;
    background: #eaf6ee;
    color: #146b32;
  }

  .rating-code--shortage {
    border-color: #c62832;
    background: #fff0f0;
    color: #a91e27;
  }

  .rating-code--metropolitan {
    border-color: #c32c68;
    background: #fff0f6;
    color: #a71f57;
  }

  .rating-code--regional {
    border-color: #c56b20;
    background: #fff5e9;
    color: #995018;
  }

  .rating-code--unknown {
    border-color: #99a3b3;
    background: #f0f2f5;
    color: #596579;
  }

  @font-face {
    font-family: 'SBS Sans';
    src: url('${path}WOFF2/SBSSans-Regular.woff2') format('woff2');
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'SBS Sans';
    src: url('${path}WOFF2/SBSSans-Bold.woff2') format('woff2');
    font-weight: 700;
    font-style: normal;
    font-stretch: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'SBS Sans';
    src: url('${path}WOFF2/SBSSansCond-Regular.woff2') format('woff2');
    font-weight: 400;
    font-style: normal;
    font-stretch: condensed;
    font-display: swap;
  }

  @font-face {
    font-family: 'SBS Sans';
    src: url('${path}WOFF2/SBSSansCond-Bold.woff2') format('woff2');
    font-weight: 700;
    font-style: normal;
    font-stretch: condensed;
    font-display: swap;
  }
`;
